import React from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import Workshopph from "../../assets/pic/workshop.jpg"
import {Helmet} from "react-helmet";

const Workshop = ()=>{
    return(
        <div className='workshop-wrap'>
            <Helmet>
                <title>رویداد آنلاین تعاملی</title>
                <meta name="description" content="برگزاری رویدادهای آنلاین (مجازی) از آنجایی که محدود به عامل مکان و زمان نیست، مزایای قابل توجهی نظیر کاهش هزینه‌های برگزارکننده و شرکت‌کننده، افزایش تعداد شرکت‌کنندگان و افزایش تعامل بین دارد." />
            </Helmet>
            <Nav/>
            <div className='webinar-dec'>
                <h1>برگزاری کارگاه آموزشی</h1>
                <img src={Workshopph} alt="برگزاری کارگاه آموزشی"/>
                <p>
                    می‌توان گفت که همه‌گیری ویروس کرونا (Covid-19)، نظام آموزشی را در سراسر جهان با تغییر و تحول اساسی روبه‌رو کرد و نظام آموزشی نوینی که شاید سال‌های آینده با آن مواجه بودیم را به سال ۲۰۱۹ آورد. تحول اصلی نظام آموزشی در نوع برگزاری آن از حضوری (فیزیکی) به آنلاین (مجازی) بود که در طی این مدت کوتاه پیشرفت‌های چشم‌گیری نیز به خود دیده است.
                </p>
                <p>
                    در همین مدت کوتاه برخی از پلتفرم‌های برگزاری رویدادهای آنلاین به بلوغ رسیده‌اند و مجهز به ابزارهای تعاملی جالب توجهی نظیر تعامل صوتی و ویدئویی با کیفیت بالا، گفتگو و تعامل متنی (چت)، اشتراک‌گذاری فایل، اشتراک‌گذاری صفحه نمایش و پخش اعلانات شده‌اند.
                </p>
                <p>
                    این ابزارهای تعاملی باعث می‌شوند که رویدادهای آنلاین با کیفیت و بازدهی بسیاری بالایی، حتی بیشتر از رویدادهای فیزیکی، برگزار شوند.
                </p>
                <p>
                    یکی از مهم‌ترین مزایاهای برگزاری رویدادهای آنلاین، عدم وابستگی به پارامتر مکان و زمان است. از آنجایی که بستر برگزاری رویدادهای آنلاین اینترنت است، در هر ساعت از شبانه‌روز و از هر نقطه جغرافیایی امکان شرکت در رویداد مذکور وجود دارد.
                </p>
                <p>
                    برگزاری یک رویداد به صورت فیزیکی به طور طبیعی منجر می‌شود که جامعه آماری کوچکی (محدود به موقعیت جغرافیایی) پیش روی شما قرار گیرد. این در صورتی است که برگزاری یک رویداد آنلاین نظیر کلاس آنلاین‌ یا کارگاه آموزشی بدون مرز است و مخاطبین شما می‌توانند از هر کشور یا شهری در رویداد آنلاین شما شرکت کنند.
                </p>
                <p>
                    پلتفرم جامع برگزاری جلسات مجازی BellMeet، تنها پتلفرم بومی و دانش بنیان با کامل‌ترین ابزارهای تعاملی نظیر:
                </p>
                <ul>
                    <li>•	تعامل صوتی با کیفیت بالا</li>
                    <li>•	تعامل تصویری با کیفیت بالا</li>
                    <li>•	گفتگو و تعامل متنی (چت)</li>
                    <li>•	پخش ویدئو آنلاین</li>
                    <li>•	به اشتراک گذاری فایل</li>
                    <li>•	به اشتراک گذاری صفحه نمایش</li>
                    <li>•	و امکان ایجاد نمایش پیام یا اعلانات مهم به صورت دوره‌ای در محیط جلسه</li>
                </ul>
                <p>
                    آماده میزبانی بستر رویداد آنلاین شما است. شما با استفاده از پلتفرم جامع BellMeet می‌توانید کلاس‌ خصوصی و کارگاه آموزشی خود را به صورت دوره‌ای و با بالاترین کیفیت ممکن برگزار کنید.
                </p>
            </div>
            <Footer/>
        </div>
    )
}

export default Workshop